/* istanbul ignore file */
import { useEffect, useState } from 'react';

import { useAuthentication } from '../authentication/authProvider';

export const WordApp = () => {
  const { accessToken } = useAuthentication();

  const [subject, setSubject] = useState<string | undefined>();

  useEffect(() => {
    Office.context.document.getFilePropertiesAsync((result) => {
      setSubject(result.value.url);
    });
  }, []);

  return (
    <div data-testid="word-app" className="bg-green-900">
      {subject} {accessToken}
    </div>
  );
};
